import { render } from "./LanguageSwitchComponent.vue?vue&type=template&id=6dfb049b&scoped=true"
import script from "./LanguageSwitchComponent.vue?vue&type=script&lang=js"
export * from "./LanguageSwitchComponent.vue?vue&type=script&lang=js"

import "./LanguageSwitchComponent.vue?vue&type=style&index=0&id=6dfb049b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfb049b"]])

export default __exports__